export default __webpack_public_path__ + "22505b81a3f67132583a5bce0d205a5b.svg";